import logger from '../utils/logger';
import { LocationFinderOptions, LocationFinderResponse } from '../types/location';
import { omniChannelApi } from '.';

export const getLocations = async (
  opts?: LocationFinderOptions,
): Promise<LocationFinderResponse> => {
  try {
    const { data } = await omniChannelApi.post(`/location-finder`, opts);
    return data;
  } catch (error) {
    logger('error', 'at getLocations while fetching nearest branch', error);
    throw new Error('error at getLocations while fetching nearest branch');
  }
};
